// 定义全局基础函数库
import Vue from 'vue'
import {strIsEmpty,
  objIsNull,
  numIsValid,
  listIsEmpty,
  boolIsTrue} from './valid/valid_util.js'

import {recoverVuex,saveInSessionStorage,requestDataIfAbsent} from './recover/recover_vuex'

import {bus} from './bus/bus'

import {delay} from './delay/delay'
import {date2Str} from './str/str_util'

import {  swap,
          up,
          down,
          bottom,
          top}  from './array/array_util'

// ***绑定到 vue 原型中，组件中使用util*********************
// md5PasswordStr = this.util.md5(passwordStr)
Vue.prototype.util = {
  strIsEmpty,
  objIsNull,
  numIsValid,
  listIsEmpty,
  boolIsTrue,
  bus,
  delay,
  date2Str,
  swap,
  up,
  down,
  bottom,
  top
}

export {
  strIsEmpty,
  objIsNull,
  numIsValid,
  listIsEmpty,
  boolIsTrue,
  recoverVuex,
  saveInSessionStorage,
  delay,
  date2Str,
  requestDataIfAbsent,
  swap,
  up,
  down,
  bottom,
  top
}